export default (params) => {
    const tourCriteria = {};
    const kids = 0;
    const infants = 0;

    let element = params.adults;
    if (element) { // обычная тур группа
        tourCriteria.touristGroup = {
            adults: element,
            kids,
            infants,
        };

        if (params.kids || params.infants) {
            element = params.kids;
            if (element) {
                tourCriteria.touristGroup.kids = element;
            }

            element = params.infants;
            if (element) {
                tourCriteria.touristGroup.infants = element;
            }
            if (params.ages) {
                tourCriteria.touristGroup.ages = _.values(params.ages);
            }
        }
    } else if (params.rooms) { // групповая тур группа
        Object.values(params.rooms).forEach((room, i) => {
            if (i === 0) {
                tourCriteria.touristGroup = {
                    adults: room.adults,
                    kids: room.kids || 0,
                    infants: room.infants || 0,
                    ages: _.values(room.ages) || [],
                    touristsByRooms: [],
                };
            } else {
                tourCriteria.touristGroup.touristsByRooms.push({
                    adults: room.adults,
                    kids: room.kids || 0,
                    infants: room.infants || 0,
                    ages: _.values(room.ages) || [],
                });
            }
        });
    }
    return tourCriteria;
};